// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAqEwvjuMv1eeDTLj7YOS0MpU-Kt5bkv44",
  authDomain: "barber-4c224.firebaseapp.com",
  databaseURL: "https://barber-4c224-default-rtdb.firebaseio.com",
  projectId: "barber-4c224",
  storageBucket: "barber-4c224.firebasestorage.app",
  messagingSenderId: "1001647584762",
  appId: "1:1001647584762:web:dbd0bd050c02590f1a2043"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
const db = getDatabase(app);

export default db;